import AssignmentTurnedInIcon from '@mui/icons-material/AssignmentTurnedIn';
import AutoGraphIcon from '@mui/icons-material/AutoGraph';
import HubIcon from '@mui/icons-material/Hub';
import SpeedIcon from '@mui/icons-material/Speed';
import { Box, Grid, Stack, Typography } from '@mui/material';
import React from 'react';

import { muiPalette } from '@/shared/general-theme';

const features = [
  {
    icon: <AssignmentTurnedInIcon />,
    title: 'Continuous Measurement',
    text: 'Move away from point-in-time audits. Update information as your program evolves.',
  },
  {
    icon: <HubIcon />,
    title: 'SME Assignments',
    text: 'Assign questionnaire sections to the subject matter experts who have the most current data.',
  },
  {
    icon: <AutoGraphIcon />,
    title: 'Evidence Generation',
    text: 'Automatically generate scorecards, diagrams, and board-ready comparison material.',
  },
  {
    icon: <SpeedIcon />,
    title: 'Integrated Tooling',
    text: 'Connect SAST, DAST, and Threat Modeling tools directly into your maturity assessment.',
  },
];

const PlatformFeatures: React.FC = () => {
  return (
    <Box sx={{ py: '3rem', px: { xs: '1.5rem', md: '4rem' }, backgroundColor: '#ffffff05', borderRadius: '0.75rem' }}>
      <Grid container spacing={6} alignItems='center'>
        <Grid size={{ xs: 12, md: 5 }}>
          <Typography variant='overline' color={muiPalette.primary.main} sx={{ fontWeight: 800, letterSpacing: 2 }}>
            THE PLATYPUS PLATFORM
          </Typography>
          <Typography variant='h3' sx={{ color: 'white', mt: '1rem', mb: '1.5rem', fontWeight: 700 }}>
            Making Measurement Continuous and Easy
          </Typography>
          <Typography variant='body1' sx={{ color: muiPalette.grey[300], fontSize: '1.1rem', mb: '2rem' }}>
            We've all experienced audits that take months and result in light, non-actionable reports.
            Platypus changes the paradigm by enabling dynamic, data-driven security management.
          </Typography>
        </Grid>

        <Grid size={{ xs: 12, md: 7 }}>
          <Grid container spacing={3}>
            {features.map((f, i) => (
              <Grid size={{ xs: 12, sm: 6 }} key={i}>
                <Stack direction='row' spacing={2}>
                  <Box
                    sx={{
                      minWidth: 48,
                      height: 48,
                      borderRadius: '0.75rem',
                      backgroundColor: `${muiPalette.primary.main}15`,
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      color: muiPalette.primary.main,
                    }}
                  >
                    {f.icon}
                  </Box>
                  <Box>
                    <Typography variant='h6' sx={{ color: 'white', mb: '0.5rem' }}>{f.title}</Typography>
                    <Typography variant='body2' sx={{ color: muiPalette.grey[400] }}>{f.text}</Typography>
                  </Box>
                </Stack>
              </Grid>
            ))}
          </Grid>
        </Grid>
      </Grid>
    </Box>
  );
};

export default PlatformFeatures;
